import { render } from "./utc-time-indicator.vue?vue&type=template&id=ec0eb6dc&ts=true"
import script from "./utc-time-indicator.ts?vue&type=script&lang=ts&external"
export * from "./utc-time-indicator.ts?vue&type=script&lang=ts&external"

import "./utc-time-indicator.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__